var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inline-flex leading-6 items-center",class:[_vm.reversed ? 'flex-row-reverse' : 'flow-row', _vm.spacings[_vm.spacing]]},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('BaseIcon',{attrs:{"name":_vm.iconName,"type":_vm.type,"classes":"h-4","rotate":_vm.rotate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }